<template lang="pug">
  div: slot
</template>

<script>
import $ from 'jquery'
import 'slick-carousel'

export default {
  name: 'UiSlider',

  // Props ---------------------------------------------------------------------
  props: {
    options: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  // Mounted -------------------------------------------------------------------
  mounted () {
    this.init()
  },

  // Destroyed -----------------------------------------------------------------
  destroyed () {
    $(this.$el).slick('unslick')
  },

  // Methods -------------------------------------------------------------------
  methods: {

    // Init
    init () {
      const $slick = $(this.$el)
      $slick.on('afterChange', this.onAfterChange)
      $slick.on('beforeChange', this.onBeforeChange)
      $slick.on('breakpoint', this.onBreakpoint)
      $slick.on('destroy', this.onDestroy)
      $slick.on('edge', this.onEdge)
      $slick.on('init', this.onInit)
      $slick.on('reInit', this.onReInit)
      $slick.on('setPosition', this.onSetPosition)
      $slick.on('swipe', this.onSwipe)
      $slick.on('lazyLoaded', this.onLazyLoaded)
      $slick.on('lazyLoadError', this.onLazyLoadError)
      $slick.slick(this.options)
    },

    // Destroy
    destroy () {
      const $slick = $(this.$el)
      $slick.off('afterChange', this.onAfterChange)
      $slick.off('beforeChange', this.onBeforeChange)
      $slick.off('breakpoint', this.onBreakpoint)
      $slick.off('destroy', this.onDestroy)
      $slick.off('edge', this.onEdge)
      $slick.off('init', this.onInit)
      $slick.off('reInit', this.onReInit)
      $slick.off('setPosition', this.onSetPosition)
      $slick.off('swipe', this.onSwipe)
      $slick.off('lazyLoaded', this.onLazyLoaded)
      $slick.off('lazyLoadError', this.onLazyLoadError)
      $(this.$el).slick('unslick')
    },

    // ReSlick
    reSlick () {
      this.destroy()
      this.init()
    },

    // Refresh
    refresh () {
      $(this.$el).slick('refresh')
    },

    // Next
    next () {
      $(this.$el).slick('slickNext')
    },

    // Prev
    prev () {
      $(this.$el).slick('slickPrev')
    },

    // Pause
    pause () {
      $(this.$el).slick('slickPause')
    },

    // Play
    play () {
      $(this.$el).slick('slickPlay')
    },

    // Go to
    goTo (index, dontAnimate) {
      $(this.$el).slick('slickGoTo', index, dontAnimate)
    },

    // Current slide
    currentSlide () {
      return $(this.$el).slick('slickCurrentSlide')
    },

    // Add
    add (element, index, addBefore) {
      $(this.$el).slick('slickAdd', element, index, addBefore)
    },

    // Remove
    remove (index, removeBefore) {
      $(this.$el).slick('slickRemove', index, removeBefore)
    },

    // Filter
    filter (filterData) {
      $(this.$el).slick('slickFilter', filterData)
    },

    // Unfilter
    unfilter () {
      $(this.$el).slick('slickUnfilter')
    },

    // Get option
    getOption (option) {
      $(this.$el).slick('slickGetOption', option)
    },

    // Set option
    setOption (option, value, refresh) {
      $(this.$el).slick('slickSetOption', option, value, refresh)
    },

    // Set position
    setPosition () {
      $(this.$el).slick('setPosition')
    },

    // Events
    onAfterChange (event, slick, currentSlide) {
      this.$emit('after-change', event, slick, currentSlide)
    },
    onBeforeChange (event, slick, currentSlide, nextSlide) {
      this.$emit('beforeChange', event, slick, currentSlide, nextSlide)
    },
    onBreakpoint (event, slick, breakpoint) {
      this.$emit('breakpoint', event, slick, breakpoint)
    },
    onDestroy (event, slick) {
      this.$emit('destroy', event, slick)
    },
    onEdge (event, slick, direction) {
      this.$emit('edge', event, slick, direction)
    },
    onInit (event, slick) {
      this.$emit('init', event, slick)
    },
    onReInit (event, slick) {
      this.$emit('reInit', event, slick)
    },
    onSetPosition (event, slick) {
      this.$emit('setPosition', event, slick)
    },
    onSwipe (event, slick, direction) {
      this.$emit('swipe', event, slick, direction)
    },
    onLazyLoaded (event, slick, image, imageSource) {
      this.$emit('lazyLoaded', event, slick, image, imageSource)
    },
    onLazyLoadError (event, slick, image, imageSource) {
      this.$emit('lazyLoadError', event, slick, image, imageSource)
    }
  }
}
</script>
